<script lang="ts">
    import {Flex} from 'shared/layouts';
    import {getLocalization} from 'src/core';
    import {KpPopover, type TogglePopoverFn} from 'shared/ui-widgets/popover';
    import {getRichtextAreaContext} from '../../richtext-area.context';
    import {get} from 'svelte/store';
    import {exists, isFunction} from 'shared/utils/custom-utils';
    import {callCommand} from '@milkdown/utils';
    import {wrapInBulletListCommand, wrapInOrderedListCommand} from '@milkdown/preset-commonmark';
    import ToolbarButton from './ToolbarButton.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';

    const {editor$} = getRichtextAreaContext();
    const localize = getLocalization();

    let togglePopover: TogglePopoverFn;
    type ListType = 'bullet' | 'ordered';

    function wrapInList(listType: ListType) {
        const editor = get(editor$);
        if (!exists(editor)) {
            return;
        }

        editor.action(
            callCommand(listType === 'bullet' ? wrapInBulletListCommand.key : wrapInOrderedListCommand.key)
        );

        if (isFunction(togglePopover)) {
            togglePopover(false);
        }
    }
</script>

<KpPopover bind:togglePopover>
    <svelte:fragment slot="whole-button" let:buttonId let:panelId let:floatingRef>
        <ToolbarButton icon="list"
                       tooltipLabel={localize(/* @kp-localization richTextArea.tools.list */ 'richTextArea.tools.list')}
                       id={buttonId}
                       popovertarget={panelId}
                       use={[floatingRef]}/>
    </svelte:fragment>

    <svelte:fragment slot="popover-content">
        <Flex direction="column">
            <KpButton buttonSize="xs" buttonStyle="no-background" on:click={() => wrapInList('bullet')}>
                {localize(/* @kp-localization richTextArea.tools.listBulletLabel */ 'richTextArea.tools.listBulletLabel')}
            </KpButton>

            <KpButton buttonSize="xs" buttonStyle="no-background" on:click={() => wrapInList('ordered')}>
                {localize(/* @kp-localization richTextArea.tools.listOrderedLabel */ 'richTextArea.tools.listOrderedLabel')}
            </KpButton>
        </Flex>
    </svelte:fragment>
</KpPopover>